/** THIS FILE IS A COPY FROM A PACKAGES: packages/hand-evaluator
 *  vite build has problems with @pushflow/database importing and etc.
 */

import { EGameType } from '@pushflow/database/prisma/types/enums'
import { evaluateCards, handRank } from 'phe'
import { EHandName } from '../types/enums'

const myHandRank = (val: number) => {
  // Hack: Treat `val == 1` as royal flush (highest hand)
  if (val === 1) return 0
  return handRank(val) + 1
}

const handNames = [
  EHandName.ROYAL_FLUSH,
  EHandName.STRAIGHT_FLUSH,
  EHandName.FOUR_OF_A_KIND,
  EHandName.FULL_HOUSE,
  EHandName.FLUSH,
  EHandName.STRAIGHT,
  EHandName.THREE_OF_A_KIND,
  EHandName.TWO_PAIR,
  EHandName.ONE_PAIR,
  EHandName.HIGH_CARD,
]

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class HandEvaluator {
  static evaluate(
    holeCards: string[],
    communityCards: string[],
    gameType: EGameType,
  ): { bestHand: string[]; handRank: number; handName: EHandName | null } {
    if (gameType === EGameType.NLH) {
      return HandEvaluator.evaluateHoldemHand(holeCards, communityCards)
    }
    if (gameType === EGameType.PLO4 || gameType === EGameType.PLO5) {
      return HandEvaluator.evaluateOmahaHand(holeCards, communityCards)
    }
    gameType satisfies never
    throw new Error(`Unsupported game type: ${gameType as string}`)
  }

  private static evaluateHoldemHand(
    holeCards: string[],
    communityCards: string[],
  ): { bestHand: string[]; handRank: number; handName: EHandName | null } {
    const allCards = holeCards.concat(communityCards)
    const fiveCardCombos = HandEvaluator.generateCombinations(allCards, 5)

    let bestHand: string[] = []
    let bestRank = Number.MAX_SAFE_INTEGER
    let bestHandName: EHandName | null = null

    for (const combo of fiveCardCombos) {
      const val = evaluateCards(combo)
      const rank = myHandRank(val)
      if (rank < bestRank) {
        bestRank = rank
        bestHand = combo
        bestHandName = handNames[rank]
      }
    }

    return { bestHand, handRank: bestRank, handName: bestHandName }
  }

  private static evaluateOmahaHand(
    holeCards: string[],
    communityCards: string[],
  ): { bestHand: string[]; handRank: number; handName: EHandName | null } {
    const holeCardCombos = HandEvaluator.generateCombinations(holeCards, 2)
    const communityCardCombos = HandEvaluator.generateCombinations(
      communityCards,
      3,
    )

    let bestHand: string[] = []
    let bestRank = Number.MAX_SAFE_INTEGER
    let bestHandName: EHandName | null = null

    for (const holeCombo of holeCardCombos) {
      for (const communityCombo of communityCardCombos) {
        const fiveCardHand = holeCombo.concat(communityCombo)
        const val = evaluateCards(fiveCardHand)
        const rank = myHandRank(val)
        if (rank < bestRank) {
          bestRank = rank
          bestHand = fiveCardHand
          bestHandName = handNames[rank]
        }
      }
    }

    return { bestHand, handRank: bestRank, handName: bestHandName }
  }

  private static generateCombinations<T>(arr: T[], k: number): T[][] {
    const results: T[][] = []
    const helper = (start: number, combo: T[]) => {
      if (combo.length === k) {
        results.push(combo)
        return
      }
      for (let i = start; i < arr.length; i++) {
        helper(i + 1, combo.concat(arr[i]))
      }
    }
    helper(0, [])
    return results
  }
}
